/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import PanelLayout, { PanelLayoutProps } from './PanelLayout';
import { ICustomElement, noShadowDOM } from 'component-register';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-panel-layout': Partial<HTMLElement> &
        PanelLayoutProps &
        Partial<{ ref: ICustomElement }>;
    }
  }
}

export function defineSolidPanelLayout(): void {
  customElement(
    'tc-panel-layout',
    {
      className: undefined,
      headerClassName: undefined,
      panelTitle: '',
      titleDataCy: undefined,
      titleSectionRight: undefined,
      rightActions: undefined,
      content: undefined,
    },
    (props) => {
      noShadowDOM();

      return (
        <PanelLayout
          className={props.className}
          headerClassName={props.headerClassName}
          panelTitle={props.panelTitle}
          titleDataCy={props.titleDataCy}
          titleSectionRight={props.titleSectionRight}
          rightActions={props.rightActions}
          content={props.content}
        />
      );
    }
  );
}
